import {createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw} from 'vue-router'
import Home from '../views/Home.vue'
import Member from "@/views/Member.vue";
import RewardDetail from "@/views/RewardDetail.vue";
import RewardList from "@/views/RewardList.vue";
import i18n, {supportedLang} from "@/locales";

const routes: RouteRecordRaw[] = [
  // {
  //   path: "/:lang",
  //   props: true,
  //   name: "-",
  //   component: {
  //     template: '<router-view />',
  //   },
  //   children: [
      {
        path: '/:lang?',
        name: 'Home',
        component: Home,
      },
      {
        path: '/:lang?/member',
        name: 'Member',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component:  Member
      },
      {
        path: '/:lang?/:category(reward|privilege|offer|event)',
        name: "List",
        props: true,
        component: RewardList,
      },
      {
        path: '/:lang?/:category(reward|privilege|offer|event)/:id([\\d\\w-]+)',
        name: "Details",
        props: true,
        component: RewardDetail
      }
    // ]
  // },
]

const router = createRouter({
  scrollBehavior: () => {
    return {top: 0, left: 0, behavior: "smooth"}
  },
  history: createWebHistory(process.env.VUE_APP_BASE_URL),
  routes,
})

router.beforeEach((to, from, next) => {
  // console.log(to.fullPath, to.params, to.query);
  // eslint-disable-next-line no-prototype-builtins
  if (!to.params.hasOwnProperty('lang')) {
    next({
      ...to,
      params: {
        ...to.params,
        lang: i18n.global.locale
      }
    })
  } else {
    i18n.global.locale = to.params.lang.toString();
    next()
  }
})

export default router
